var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticStyle:{"margin-right":"10px"}},[_vm._v(" "+_vm._s(_vm.item.pageStart)+"-"+_vm._s(_vm.item.pageStop)+" of "+_vm._s(_vm.item.itemsLength)+" ")]),_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({on:{"click":_vm.action}},'v-icon',attrs,false),on),[_vm._v(" mdi-refresh ")])]}}])},[_c('span',[_vm._v("Refresh")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }